import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import {requestGetUserEmailList} from "@app/services/UserService";
import {optionsToString, stringToOption} from "@app/utils/CommonUtils";
import Select from "react-select";
import UserEmailListTable from "@pages/user/UserEmailListTable";

const FullMailChooseYourEmails = (props) => {
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [yourAllEmails, setYourAllEmails] = useState([]);
    const [yourEmailOptions, setYourEmailOptions] = useState([]);
    const [yourSelectedEmails, setYourSelectedEmails] = useState([]);
    const {sendingEmails, onChange} = props

    const fetchUserEmails = async (userId) => {
        const res = await requestGetUserEmailList({user_id: userId});
        const emailList = res.content.user_emails
        const emailOptionList = []
        emailList.forEach(item => {
            emailOptionList.push({value: item.email, label: item.email})
        })
        setYourEmailOptions(emailOptionList);
        setYourAllEmails(emailList)
    }

    useEffect(() => {
        const strUserLogin = localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)
        if (!userLoginInfo.id && strUserLogin) {
            const userLogin = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(userLogin)

            fetchUserEmails(userLogin.id)
        }
    }, [])

    useEffect(() => {
        if (sendingEmails) {
            setYourSelectedEmails(stringToOption(sendingEmails))
        }
    }, [sendingEmails])

    const onChangeYourSelectedEmails = (values) => {
        setYourSelectedEmails([...values]);
        onChange(optionsToString(values))
    };

    const onChangeItemIndex = (currIndex, newIndex) => {
        if (newIndex < 0 || newIndex > yourSelectedEmails.length - 1) {
            return;
        }

        const item = yourSelectedEmails[currIndex];
        yourSelectedEmails.splice(currIndex, 1);
        yourSelectedEmails.splice(newIndex, 0, item);

        setYourSelectedEmails([...yourSelectedEmails])

    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title'><b>Sending Emails</b></h3>
                    <div className={'float-right col-sm-9 p-0'}>
                        <Select options={yourEmailOptions} isMulti
                                value={yourSelectedEmails}
                                placeholder={'Chọn your emails...'}
                                onChange={values => {
                                    onChangeYourSelectedEmails(values);
                                }}
                        />
                    </div>
                </div>
                <div className='card-body p-0'>
                    <div className='card-body table-responsive p-0 w-100'>
                        <table
                            className='table table-hover table-bordered text-nowrap text-center'
                            style={{
                                maxHeight: '80vh',
                                overflow: 'scroll',
                            }}
                        >
                            <thead>
                            <tr>
                                <th>STT</th>
                                <th>Email</th>
                                <th>Hành động</th>
                            </tr>
                            </thead>
                            <tbody>
                            {yourSelectedEmails.map((item, index) => {
                                return <tr key={`user_emails_${index}`}>
                                    <td>{index+1}</td>
                                    <td>{item.value}</td>
                                    <td>
                                        {index > 0 &&
                                        <button className='btn btn-default btn-sm' type='button'
                                                onClick={() => onChangeItemIndex(index, index - 1)}>
                                            Up
                                        </button>
                                        }
                                        {index < yourSelectedEmails.length - 1 &&
                                        <button className='btn btn-default btn-sm ml-2' type='button'
                                                onClick={() => onChangeItemIndex(index, index + 1)}>
                                            Down
                                        </button>
                                        }
                                    </td>
                                </tr>
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FullMailChooseYourEmails;
